import { STATUS } from "../../../constants/ApiEnums";

export const statusOptions =
    Object.entries(STATUS)
        .map(([key, value]) => (
            { value: key, label: `${key} - ${value}` }
        ))